import { IResponse, IResponseList, IResponsePagination } from '@/types/common';
import {
  ICreateOfferRequest,
  IGetListOfferRequest,
  IUpdateOfferRequest,
} from '@/types/request/offer';
import { IGetListOfferResponse, IOffer } from '@/types/response/offer';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class Offer {
  getList = (
    params: IGetListOfferRequest,
  ): Promise<IResponsePagination<IGetListOfferResponse>> => {
    return axiosClient.get(ENDPOINT.OFFER.GET_LIST, { params });
  };

  getForSelect = (
    params: IGetListOfferRequest,
  ): Promise<IResponsePagination<IGetListOfferResponse>> => {
    return axiosClient.get(ENDPOINT.OFFER.GET_FOR_SELECT, {
      params: params,
    });
  };

  delete = (id: number) => {
    return axiosClient.delete(ENDPOINT.OFFER.DELETE.replace(':id', String(id)));
  };

  create = (body: ICreateOfferRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.OFFER.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<any>> => {
    return axiosClient.get(
      ENDPOINT.OFFER.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (data: IUpdateOfferRequest, id: number): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.OFFER.UPDATE.replace(':id', String(id)),
      data,
    );
  };
  getCheckboxList = ({
    bannerId,
    fukumaruQuizId,
    chatFukumaruId
  }: {
    bannerId?: number | string;
    fukumaruQuizId?: number | string;
    chatFukumaruId?: number | string;
  }): Promise<IResponseList<IOffer>> => {
    return axiosClient.get(ENDPOINT.OFFER.GET_CHECKBOX_LIST, {
      params: { bannerId, fukumaruQuizId, chatFukumaruId },
    });
  };
}

export const OfferService = new Offer();
